<template>
<div>
  <form class="form-horizontal" @submit.prevent="submit">
    <fieldset>
      <legend>Dane ogólne</legend>
      <form-group label="Nazwa" :error="errors['name']">
        <text-input v-model="producer.name"></text-input>
      </form-group>

      <form-group label="Link" :error="errors['link']">
        <text-input v-model="producer.link"></text-input>
      </form-group>

      <form-group label="Opis" :error="errors['description']">
        <textarea-input v-model="producer.description" rows="5"></textarea-input>
      </form-group>

      <form-group label="Godziny otwarcia" :error="errors['openingHours']">
        <textarea-input v-model="producer.openingHours" rows="5"></textarea-input>
      </form-group>
    </fieldset>

    <fieldset>
      <legend>Produkty producenta</legend>
      <form-group label="Produkty" :error="errors['products']">
        <v-select multiple v-model="producer.products" :options="productsOptions"></v-select>
      </form-group>
    </fieldset>

    <fieldset>
      <legend>Logo</legend>
      <form-group label="Logo" :error="errors['logo']">
        <media-input v-model="producer.logo"></media-input>
      </form-group>
    </fieldset>

    <submit-button :submitting="submitting"></submit-button>
  </form>
</div>
</template>
<script>
import FormGroup from './FormGroup.vue'
import TextInput from './TextInput.vue'
import FileInput from './FileInput.vue'
import MediaInput from './MediaInput.vue'
import TextareaInput from './TextareaInput.vue'
import SubmitButton from './SubmitButton.vue'
import SelectInput from './SelectInput.vue'
import TableInput from './TableInput.vue'
import Api from './../api'
import flash from './../Flash'
import vSelect from 'vue-select'

export default {
  props: {
    id: {type: [String, Number]}
  },
  components: {
    FormGroup,
    TextInput,
    FileInput,
    MediaInput,
    TextareaInput,
    SubmitButton,
    SelectInput,
    TableInput,
    vSelect,
    Api
  },
  data () {
    return {
      submitting: false,
      producer: {
        name: '',
        description: '',
        logo: null,
        products: [],
        openingHours: ''
      },
      productsOptions: [],
      errors: []
    }
  },
  methods: {
    buildLabel (p) {
      return `${p.name} - ${p.variety ? p.variety + ', ' : ''} ${p.origin}, ${p.unit}`
    },
    submit () {
      this.errors = []
      this.submitting = true
      if (this.id) {
        let producer = {...this.producer}
        if (producer.products.length > 0) {
          producer.products = this.producer.products.map(p => {
            return `/api/products/${p.value}`
          })
        }
        Api.producer.update(this.id, producer).then(this.updateSuccess, this.updateError).then(() => { this.submitting = false })
      } else {
        let producer = {...this.producer}
        if (producer.logo) {
          producer.logo = `/api/files/${this.producer.logo.id}`
        }
        if (producer.products.length > 0) {
          producer.products = this.producer.products.map(p => {
            return `/api/products/${p.value}`
          })
        }
        Api.producer.post(producer).then(this.updateSuccess, this.updateError).then(() => { this.submitting = false })
      }
    },
    updateSuccess ({body}) {
      this.producer = this.transform(body)
      flash.success('Zapisano zmiany poprawnie')
      this.$router.push({
        name: 'ProducerEdit',
        params: {
          id: this.producer.id
        }
      })
    },
    updateError ({body}) {
      const violations = body.violations
      violations.forEach(violation => {
        this.errors[violation.propertyPath] = violation.message
      })
    },
    fetchData () {
      Api.product.getList().then(this.onFetchProductsSuccess, this.onFetchProductsError)
      if (this.id) {
        Api.producer.get(this.id).then(this.fetchSuccess)
      }
    },
    onFetchProductsSuccess ({body}) {
      this.productsOptions = body.map(p => {
        return {
          label: this.buildLabel(p),
          value: p.id
        }
      })
    },
    onFetchProductsError () {
      window.alert('Wystąpił nieoczekiwany błąd podczas pobierania produktów - skontaktuj się z administratorem')
    },
    fetchSuccess ({body}) {
      this.producer = this.transform(body)
    },
    transform (body) {
      body.products = body.products.map(p => {
        return {
          label: this.buildLabel(p),
          value: p.id
        }
      })
      return body
    }
  },
  created () {
    this.fetchData()
  }
}
</script>



// WEBPACK FOOTER //
// ProducerAddEdit.vue?4db5ffbc